export default "__VITE_ASSET__CiAQOHlN__"